// Account entity manifest: card-only. Account has no page or surface — it is a CRM Contact shown
// as a card in the tenant app and in both portals, which reuse the same card.
import { ActivityEntityName, Contact, DomainType } from '@jms/model';
import type { EntityManifestCard } from '@workbuddy/services/entities/entity.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

const card: EntityManifestCard<Contact> = {
  component: () => import('./entity.card.renderer/account.entity.card.renderer.component').then(module => module.AccountEntityCardRendererComponent),
  resolution: 'if-needed',
  isComplete: value => !!(value.mobile || value.phone || value.workPhone || value.email),
  summarize: value => ({ title: value.name ?? 'Not set' }),
};

export const accountManifest = registerManifest<Contact>({
  entity: ActivityEntityName.Account,
  slug: 'account',
  presentation: { card },
  domains: {
    [DomainType.ClientPortal]: { presentation: { card } },
    [DomainType.ContractorPortal]: { presentation: { card } },
  },
});
